import { CardHeader, useMediaQuery } from '@mui/material'
import { FC } from 'react'
import { ProNLI } from '../model/pro-nl'
import {
    CardContainer,
    CardCategory,
    CardImage,
    CategoryName,
    CardAuthorPRO
} from '../style/post-page'
import { AlertaContent } from '../utils/geral'
import { TagDS } from './geral/JOTADS.components'
import { BREAKPOINTS } from '../utils/constants/layout'
import { ALERTAS, PRO } from '../utils/constants/pro'
import { useRouter as nextRouter } from 'next/router'
import { VerticalType } from '../interfaces/PRO.interfaces'
import { getColorVertical } from '../utils/pro'
import { CardTitle } from '@App/static/styles/global'

type ProContentHeaderProps = {
    contentPro: ProNLI | AlertaContent
}
export const ProContentHeader: FC<ProContentHeaderProps> = ({ contentPro }) => {
    const { query } = nextRouter()

    contentPro =
        contentPro.type === ALERTAS
            ? (contentPro as AlertaContent)
            : (contentPro as ProNLI)

    const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS.SM}px)`)
    return (
        <CardContainer>
            {!isMobile && (
                <CardHeader style={{ padding: '0' }}>
                    <TagDS
                        label={
                            'category' in contentPro
                                ? contentPro.category.vertical.name.toUpperCase()
                                : PRO.ALERTAS
                        }
                        onClick={() => {
                            return null
                        }}
                        color={getColorVertical(
                            'category' in contentPro
                                ? (contentPro.category.vertical
                                      .name as VerticalType)
                                : (PRO.PODER as VerticalType)
                        )}
                        size='medium'
                        type='filled'
                    />
                </CardHeader>
            )}
            <CardCategory>
                {isMobile && (
                    <TagDS
                        label={
                            'category' in contentPro
                                ? contentPro.category.vertical.name.toUpperCase()
                                : PRO.PODER
                        }
                        onClick={() => {
                            return null
                        }}
                        color={getColorVertical(
                            'category' in contentPro
                                ? (contentPro.category.vertical
                                      .name as VerticalType)
                                : (PRO.PODER as VerticalType)
                        )}
                        size='medium'
                        type='filled'
                    />
                )}
                {!isMobile && (
                    <CardImage
                        src={
                            'category' in contentPro
                                ? contentPro.category.icon
                                : query.vertical == 'poder'
                                  ? '/images/icons/alerts-icon.svg'
                                  : '/images/icons/alerts-saude-icon.svg'
                        }
                    />
                )}
                <CategoryName
                    color={
                        'category' in contentPro
                            ? (contentPro.category.vertical
                                  .name as VerticalType)
                            : query.vertical == 'poder'
                              ? (PRO.PODER as VerticalType)
                              : (PRO.SAUDE as VerticalType)
                    }
                >
                    {'category' in contentPro
                        ? contentPro.category.name
                        : PRO.ALERTAS}
                </CategoryName>
                <TagDS
                    label='PRO'
                    onClick={() => {
                        return null
                    }}
                    size='medium'
                    type='outline'
                    color={'jotaBlack'}
                />
            </CardCategory>

            <div data-cy='pro-title'>
                <CardTitle>{contentPro.title}</CardTitle>
            </div>

            <CardAuthorPRO>
                Equipe JOTA PRO{' '}
                {'category' in contentPro && contentPro.category.vertical.name}
            </CardAuthorPRO>
        </CardContainer>
    )
}
